var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFurnished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22098 20V10.8954C3.22098 10.6118 2.99107 10.3819 2.70745 10.3819C2.19838 10.3819 1.99956 9.72084 2.42417 9.44003L11.6021 3.37024C11.9408 3.1463 12.3812 3.1493 12.7167 3.37783L21.6787 9.48194C22.0795 9.75495 21.8863 10.3819 21.4013 10.3819C21.1292 10.3819 20.9086 10.6025 20.9086 10.8746V20C20.9086 20.5523 20.4609 21 19.9086 21H4.22098C3.6687 21 3.22098 20.5523 3.22098 20Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27374 18.2471L6.98718 18.2434C6.43994 18.2364 6 17.7907 6 17.2435V14C6 13.3471 6.41738 12.9678 7.13966 12.9268M7.27374 18.2471V18.2626C7.27374 18.6698 7.6056 19 8.01287 19V19C8.41827 19 8.7486 18.6714 8.7486 18.266V18.266M7.27374 18.2471L8.7486 18.266M8.7486 18.266L15.1173 18.3476M15.1173 18.3476V18.3476C15.1173 18.7079 15.4094 19 15.7697 19H15.9587C16.3086 19 16.5922 18.7164 16.5922 18.3665V18.3665M15.1173 18.3476L16.5922 18.3665M16.5922 18.3665L16.9872 18.3716C17.5444 18.3787 18 17.929 18 17.3717V14C18 13.5612 17.7577 12.9834 16.9274 12.9274M7.13966 12.9268C7.18326 12.9243 7.22796 12.923 7.27374 12.923C8.07821 12.923 8.54749 13.4615 8.54749 14V15.4615H15.5196V14C15.5196 13.3047 16 12.9274 16.7933 12.923C16.8396 12.9228 16.8843 12.9245 16.9274 12.9274M7.13966 12.9268V12C7.13966 11.3333 7.47486 10 8.81564 10C10.1564 10 13.5754 10 15.2514 10C15.8547 10 16.9274 10.4 16.9274 12V12.9274",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurnished);
export default __webpack_public_path__ + "static/media/furnished.21577dd9e4c60f27701e6f90e8762119.svg";
export { ForwardRef as ReactComponent };